import React from 'react';
import { Modal, Box, Typography, Button, Grid, makeStyles } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(() => ({
  modalBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    backgroundColor: '#fff',
    borderRadius: '16px',
    boxShadow: 24,
    padding: 32,
    textAlign: 'center',
    outline: 'none',
  },
  icon: {
    color: '#008002',
    fontSize: 72,
    marginBottom: 16,
    marginTop: 16,
  },
  title: {
    fontWeight: 700,
    marginBottom: 8,
  },
  message: {
    marginBottom: 26,
    color: '#444',
    fontSize: 16,
  },
  gridContainer: {
    marginBottom: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 20,
  },
  gridItem: {
    maxWidth: 200,
  },
  label: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  value: {
    fontSize: 14,
    marginBottom: 24,
  },
  button: {
    position: 'relative',
    padding: '5px 5px',
    backgroundColor: '#FF6B35',
    borderRadius: '999px',
    width: 150,
    textTransform: 'none',
    color: '#fff',
  },
  buttonText: {
    fontSize: 16,
    fontWeight: 500,
    width: '100%',
  },
  iconChevron: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 20,
  },
}));

export default function CMOSuccessModal({ open, onClose, cmoData }) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="cmo-success-title">
      <Box className={classes.modalBox}>
        <CheckCircleIcon className={classes.icon} />

        <Typography id="cmo-success-title" variant="h6" className={classes.title}>
          CMO added successfully
        </Typography>

        <Typography className={classes.message}>
          The invitation has been sent to the user via email.
        </Typography>

        <Grid container spacing={6} justifyContent="center" className={classes.gridContainer}>
          <Grid item xs={6} className={classes.gridItem}>
            <Box>
              <Typography align="left" className={classes.label} gutterBottom>
                CMO Short Name
              </Typography>
              <Typography align="left" className={classes.value}>
                {cmoData?.shortName || '-'}
              </Typography>

              <Typography align="left" className={classes.label} gutterBottom>
                Email Address
              </Typography>
              <Typography align="left" className={classes.value.replace('marginBottom: 24', '')}>
                {cmoData?.email || '-'}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} className={classes.gridItem}>
            <Box>
              <Typography align="left" className={classes.label} gutterBottom>
                Organization Code
              </Typography>
              <Typography align="left" className={classes.value}>
                {cmoData?.orgCode || '-'}
              </Typography>

              <Typography align="left" className={classes.label} gutterBottom>
                Phone
              </Typography>
              <Typography align="left" className={classes.value.replace('marginBottom: 24', '')}>
                {cmoData?.phone || '-'}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Button variant="contained" onClick={onClose} className={classes.button}>
          <Typography align="center" className={classes.buttonText}>
            Ok
          </Typography>
          <ChevronRightIcon className={classes.iconChevron} />
        </Button>
      </Box>
    </Modal>
  );
}
